import { render, staticRenderFns } from "./InventoryHealth.vue?vue&type=template&id=a9008708&scoped=true&"
import script from "./InventoryHealth.vue?vue&type=script&lang=ts&"
export * from "./InventoryHealth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9008708",
  null
  
)

export default component.exports